import React, { useCallback } from 'react'
import { BadgeCounter, CustomAnchor, ListItem } from '..'
import { getParsedDate } from '../../utils'
import PageLoader from '../page-loader'

const PastChats = ({ onClickChat, loading, data: pastChats, onClickDelete }) => {

    const onClickPastChat = useCallback((pastChatData) => {
        if (onClickChat) {
            onClickChat(pastChatData)
        }
    }, [onClickChat])

    const onClickDeleteChat = useCallback((chatId) => {
            if (onClickDelete) {
                onClickDelete(chatId)
            }
    }, [onClickDelete])

    return (
        <>
            <div className='bimmatch-past-chats'>
                <div className='past-chat-header'>
                    <p className='past-chat-title'>Past chats</p>
                    <BadgeCounter 
                        count={pastChats?.length || 0}
                        imgSrc='/images/icon/history.svg' 
                    />
                </div>
                {loading ? (
                    <PageLoader />
                ) : (
                    <>
                        {
                            (pastChats && (pastChats.length > 0)) && (
                                <div className='chats'>
                                    {pastChats.map((pastChatData, index) => (
                                            <ListItem
                                                key={pastChatData?.id || pastChatData?.chatId || `pastChatData-${index}`}
                                                title={<CustomAnchor className='chat-title-text' onClick={() => onClickPastChat(pastChatData)}>{pastChatData?.title || pastChatData?.chatId}</CustomAnchor>}
                                                titleTooltip={pastChatData?.title || pastChatData?.chatId}
                                                updatedAt={getParsedDate(pastChatData.updatedAt || pastChatData.createdAt)}
                                                optionMenuItems={[{ id: "delete", src: "/images/icon/trash.svg", label: "Delete", onClick: () => onClickDeleteChat(pastChatData) }]}
                                                popoverClassName={'past-chat-popover'}
                                            />
                                    ))}
                                </div>
                            )
                        }
                    </>
                )}
            </div>
        </>
    )
}

export default PastChats